import React, { useState } from 'react';
import './InitialDescription.scss';
import { Button, Icon } from '@pwc/pwc-deals-ui';
import { sanitize } from '../../../services/sanitizeService';

const InitialDescription = ({ initialDescription }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="initial-description-wrapper">
      <Button
        onClick={() => setIsExpanded(!isExpanded)}
        className="button-no-underline"
      >
        <Icon name={isExpanded ? 'desc' : 'asc'} />
        <span className="initial-description-button-text">
          Initial response
        </span>
      </Button>
      {isExpanded && (
        <>
          <br />
          <div
            className="category-description"
            dangerouslySetInnerHTML={{ __html: sanitize(initialDescription) }}
          />
        </>
      )}
    </div>
  );
};

export default InitialDescription;
